import { PLANNER_ANALYTICS_SOURCE } from '@bridebook/web/lib/ai-planner/client-actions/agent-dispatch';
import { withSourceParam } from '@bridebook/web/lib/utils/url';

// Marks an in-app path the planner links to or opens, so the visit is attributed to it.
export const withPlannerSource = (href: string): string =>
  withSourceParam(href, PLANNER_ANALYTICS_SOURCE);
